/*
 * Module handling tenant profile stuff
 */

define([
  "marionette",
  "backbone",
  "underscore",
  "messaging/messenger",
  "./tenantProfileView",
  "modules/shared/adminMenu/adminMenuModule",
  "./tenantInfo/tenantInfoModule",
  "./tenantUsers/tenantUsersModule",
  "./tenantProfileModel",
  "modules/accountAdmin/kbRoleAdmin/kbRoleList/kbRoleListModule",
  "modules/accountAdmin/kbRoleAdmin/kbRoleDetails/kbRoleDetailsModule",
  "modules/accountAdmin/departmentAdmin/departmentList/departmentListModule",
  "modules/accountAdmin/departmentAdmin/departmentDetails/departmentDetailsModule",
  "modules/accountAdmin/apiKeyAdmin/apiKeyList/apiKeyListModule",
  "modules/accountAdmin/apiKeyAdmin/apiKeyDetails/apiKeyDetailsModule",
], function (
  Marionette,
  Backbone,
  _,
  Messenger,
  TenantProfileView,
  AdminMenuModule,
  TenantInfoModule,
  TenantUsersModule,
  TenantProfileModel,
  KbRoleListModule,
  KbRoleDetailsModule,
  DepartmentListModule,
  DepartmentDetailsModule,
  ApiKeyListModule,
  ApiKeyDetailsModule,
) {
  "use strict";

  return Marionette.Controller.extend({
    initialize: function (options) {
      this.name = "tenantProfile";
      this.region = options.region;
      this._setUpVents();
    },
    show: function (options) {
      if (options.tenant) {
        this.tenant = options.tenant;
      } else if (options.tenantId) {
        const tenants = Messenger.reqres.request("tenants");
        tenants.onSynced(function () {
          const tenant = tenants.get(options.tenantId);
          if (tenant) {
            options.tenant = tenant;
            this.show(options);
          }
        }, this);
        return;
      } else {
        return;
      }

      Messenger.command.execute("set:active:tenant", this.tenant);

      this.layout = new TenantProfileView.tenantProfileLayout();

      this.sideMenu = this.addSubModule(new AdminMenuModule({ region: this.layout.sideMenu }));
      this.tenantInfo = this.addSubModule(
        new TenantInfoModule({
          region: this.layout.tenantProfile,
          model: this.tenant,
        }),
      );
      this.departments = this.addSubModule(
        new DepartmentListModule({
          region: this.layout.tenantProfile,
          model: this.tenant,
          namespace: "departments",
        }),
      );
      this.department = this.addSubModule(
        new DepartmentDetailsModule({
          region: this.layout.tenantProfile,
          tenant: this.tenant,
        }),
      );
      this.kbRoles = this.addSubModule(
        new KbRoleListModule({
          region: this.layout.tenantProfile,
          model: this.tenant,
          namespace: "roles",
        }),
      );
      this.kbRole = this.addSubModule(
        new KbRoleDetailsModule({
          region: this.layout.tenantProfile,
          tenant: this.tenant,
        }),
      );
      this.tenantUsers = this.addSubModule(
        new TenantUsersModule({
          region: this.layout.tenantProfile,
          model: this.tenant,
        }),
      );
      this.apiKeyList = this.addSubModule(
        new ApiKeyListModule({
          region: this.layout.tenantProfile,
          tenant: this.tenant,
          namespace: "apiKeys",
        }),
      );
      this.apiKeyDetails = this.addSubModule(
        new ApiKeyDetailsModule({
          region: this.layout.tenantProfile,
          tenant: this.tenant,
        }),
      );

      this.layout.on(
        "show",
        function () {
          this._showSubViews(options);
        },
        this,
      );

      this.showRegion(this.layout);
    },
    _showSubViews: function (options) {
      const menuItems = Messenger.reqres.request("tenant:admin:menu:items");
      const menuStyle = Messenger.reqres.request("tenant:admin:menu:style");
      const submodelType = options.submodelType || "info";
      this.sideMenu.show(menuStyle, menuItems, "tenant:profile", submodelType);
      // noinspection JSUnreachableSwitchBranches
      switch (submodelType) {
        case "apiKeys":
          if (options.submodelId) {
            this.apiKeyDetails.show({ apiKeyId: options.submodelId });
          } else {
            this.apiKeyList.show();
          }
          break;
        case "departments":
          if (options.submodelId) {
            this.department.show({ departmentId: options.submodelId });
          } else {
            this.departments.show();
          }
          break;
        case "roles":
          if (options.submodelId) {
            this.kbRole.show({ roleId: options.submodelId });
          } else {
            this.kbRoles.show();
          }
          break;
        case "users":
          Messenger.vent.trigger("show:tenant:profile:users", { userId: options.submodelId });
          break;
        default:
          Messenger.vent.trigger("show:tenant:profile:info");
          break;
      }
    },
    _setUpVents: function () {
      //Show the tenant admin screen
      Messenger.vent.on(
        "show:account:admin:tenant:profile",
        function (options) {
          this.show(options);
        },
        this,
      );
      Messenger.vent.on(
        "roles:selected:row",
        function (kbRole) {
          Messenger.vent.trigger("show:tenant:profile:role", { role: kbRole });
        },
        this,
      );
    },
  });
});
